import React from "react";
import { jsPDF } from "jspdf";
import { BasicButton, ButtonColor } from "../core/core-widgets";
import { DelimitedSection } from "../core/core-widgets/surfaces/DelimitedSection/DelimitedSection";

export const ExportMapCanvas = () => {
    const canvasIdentifier = "canvas";
    const openExportToPdfForm = () => {
        let canvas: HTMLCanvasElement = document.querySelector(canvasIdentifier) as HTMLCanvasElement;

        let destinationCanvas = document.createElement("canvas");
        destinationCanvas.width = canvas.width;
        destinationCanvas.height = canvas.height;

        let destCtx = destinationCanvas.getContext("2d") as CanvasRenderingContext2D;
        destCtx.fillStyle = "#FFFFFF";
        destCtx.fillRect(0, 0, canvas.width, canvas.height);
        destCtx.drawImage(canvas, 0, 0);

        let data = destinationCanvas.toDataURL("image/jpeg");

        let pdf = new jsPDF("landscape", undefined, "a4");
        pdf.addImage(data, "JPEG", 0, 0, 297, 210);
        pdf.save("map.pdf");
    };
    return (
        <DelimitedSection title={"Export map to PDF"}>
            <div id={"export-map-to-pdf"}>
                <BasicButton color={ButtonColor.PRIMARY} onClick={openExportToPdfForm}>
                    Save to PDF
                </BasicButton>
            </div>
        </DelimitedSection>
    );
};
